import * as React from 'react';
import { BASE_URL } from '../../../actions/constant'

const cekKontrak = async props => {
    let config = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({no_kontrak:props.nomor_kontrak})
                }
    let stat = await fetch(BASE_URL + 'check_kontrak', config)
    if (!stat.ok) {
        throw Error(stat.statusText)
    }
    const data = await stat.json()
    return data
}

export default cekKontrak